//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import { gmToolNew } from "@/mixins/index";
import { vipEmailList } from "@/api/gmToolNew/gmToolNew";
import viewArticles from "../../email/components/viewArticles.vue";
export default {
  mixins: [gmToolNew],
  components: {
    viewArticles: viewArticles
  },
  data: function data() {
    return {
      dialogShow: false,
      inviteList: [],
      type: '',
      paramsData: {
        role_id: '',
        server_id: ''
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(row) {
      this.paramsData.role_id = row.role_id;
      this.paramsData.server_id = row.server_id;
      this.getList(1);
      this.dialogShow = true;
    },
    getList: function getList(e) {
      var _this = this;

      this.paramsData.page = e;
      vipEmailList(this.paramsData).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      });
    }
  }
};